<!-- eslint-disable no-redeclare -->
<template>
  <div class="cardControl">
    <table>
      <tr>
        <td>roomPath：</td>
        <td colspan="9" id="uid" contenteditable="true" style="text-align: left">
          <select id="roomPath" v-model="roomId">
            <option value="61">普通局</option>
            <option value="91">奥马哈</option>
            <option value="93">奥马哈-AOF</option>
            <option value="63">德州-AOF</option>
            <option value="21">短牌</option>
            <option value="23">短牌-AOF</option>
          </select>
          <!-- <input id="uid_input" style="height: 40px;width: 100%;line-height: 40px;" placeholder="请输入"> -->
        </td>
      </tr>
      <tr>
        <td>RID：</td>
        <td colspan="9" id="rid" contenteditable="true">
          <input
            id="rid_input"
            style="height: 40px; width: 100%; line-height: 40px"
            placeholder="请输入"
          />
        </td>
      </tr>
      <tr>
        <td>PC（公共牌5张）：</td>
        <td colspan="9" id="pcs" data-value="" data-num="5" @click="setDialog"></td>
      </tr>
      <tr>
        <td>S：</td>
        <td>0（D）</td>
        <td>1</td>
        <td>2</td>
        <td>3</td>
        <td>4</td>
        <td>5</td>
        <td>6</td>
        <td>7</td>
        <td>8</td>
      </tr>
      <tr v-if="roomId === '91' || roomId === '93'">
        <td>HC（手牌2张，奥马哈四张）：</td>
        <td id="hcs1" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs2" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs3" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs4" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs5" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs6" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs7" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs8" data-value="" data-num="4" @click="setDialog"></td>
        <td id="hcs9" data-value="" data-num="4" @click="setDialog"></td>
      </tr>
      <tr v-else>
        <td>HC（手牌2张，奥马哈四张）：</td>
        <td id="hcs1" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs2" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs3" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs4" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs5" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs6" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs7" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs8" data-value="" data-num="2" @click="setDialog"></td>
        <td id="hcs9" data-value="" data-num="2" @click="setDialog"></td>
      </tr>
      <tr>
        <td></td>
        <td colspan="9"><input type="button" value="确定" @click="saveFunc()" /></td>
      </tr>
    </table>

    <div id="dialog">
      <div class="dialog-content">
        <h3>Select<span id="selectNum"></span></h3>
        <div id="numBox">
          <label v-for="i of 51" :key="i">
            <input
              type="checkbox"
              :data-text="numberToCard(i)"
              :value="i"
              name="number"
              @change="numberChangeDefault"
            />
            <span :class="Math.floor(i / 13) == 1 || Math.floor(i / 13) == 3 ? '' : 'red'">{{
              numberToCard(i)
            }}</span> </label
          >'
        </div>
        <p>
          <input id="resetBtn" data-value="" type="button" value="取消" @click="resetValue" />
          <input
            id="selectBtn"
            data-id=""
            data-num=""
            type="button"
            value="确定"
            @click="selectCard()"
          />
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {
      roomId: '61',
    };
  },
  mounted() {
    // this.number();
  },
  methods: {
    ...mapActions('cardControl', ['setCard']),

    number() {
      var html = '';

      for (var i = 0; i <= 51; i++) {
        if (Math.floor(i / 13) == 1 || Math.floor(i / 13) == 3) {
          html +=
            '<label>' +
            '<input type="checkbox" data-text="' +
            this.numberToCard(i) +
            '" value="' +
            i +
            '" name="number" onchange="numberChange(this)"/>' +
            '<span>' +
            this.numberToCard(i) +
            '</span>' +
            '</label>';
        } else {
          html +=
            '<label>' +
            '<input type="checkbox" data-text="' +
            this.numberToCard(i) +
            '" value="' +
            i +
            '" name="number" onchange="numberChange(this)"/>' +
            '<span style="color:red;">' +
            this.numberToCard(i) +
            '</span>' +
            '</label>';
        }
      }
      document.getElementById('numBox').innerHTML = html;
    },

    numberToCard(num) {
      var colors = ['♦️ ', '♣️ ', '♥️ ', '♠️ '];
      var color = colors[Math.floor(num / 13)];
      var card = (num % 13) + 2;

      if (card <= 10) {
        card = card + color;
      } else if (card == 11) {
        card = 'J' + color;
      } else if (card == 12) {
        card = 'Q' + color;
      } else if (card == 13) {
        card = 'K' + color;
      } else if (card == 14) {
        card = 'A' + color;
      }
      return card;
    },

    toggleDialog() {
      if (document.getElementById('dialog').style.display === 'block') {
        document.getElementById('dialog').style.display = 'none';
      } else {
        document.getElementById('dialog').style.display = 'block';
      }
    },

    resetValue(e) {
      var obj = e.currentTarget;
      var el = document.getElementById(document.getElementById('selectBtn').dataset.id);
      el.dataset.value = obj.dataset.value;
      if (obj.dataset.value) {
        var arr = obj.dataset.value.split(';');
        var numbers = document.getElementsByName('number');
        for (var i = 0; i < arr.length; i++) {
          for (var j = 0; j < numbers.length; j++) {
            if (arr[i] === numbers[j].value) {
              numbers[j].disabled = true;
              numbers[j].checked = true;
            }
          }
        }
        // arr.forEach(function (val) {
        //     numbers.forEach(function (num) {
        //         if (val === num.value) {
        //             num.disabled = true;
        //             num.checked = true;
        //         }
        //     });
        // });
      }
      this.toggleDialog();
    },

    setDialog(e) {
      var obj = e.currentTarget;
      document.getElementById('selectBtn').disabled = true;
      document.getElementById('selectBtn').dataset.id = obj.id;
      document.getElementById('selectBtn').dataset.num = obj.dataset.num;
      document.getElementById('resetBtn').dataset.value = obj.dataset.value;
      document.getElementById('selectNum').innerText = obj.dataset.num;

      const numbers = document.getElementsByName('number');

      for (let i = 0; i < numbers.length; i++) {
        if (!numbers[i].disabled && numbers[i].checked) {
          numbers[i].checked = false;
        }
      }
      // numbers.forEach(function (num) {
      //     if (!num.disabled && num.checked) {
      //         num.checked = false;
      //     }
      // });
      if (obj.dataset.value) {
        var arr = obj.dataset.value.split(';');
        const numbers = document.getElementsByName('number');
        // arr.forEach(function (val) {
        //     numbers.forEach(function (num) {
        //         if (val === num.value) {
        //             num.disabled = false;
        //             num.checked = true;
        //             obj.dataset.value = '';
        //         }
        //     });
        // });
        for (let i = 0; i < arr.length; i++) {
          for (var j = 0; j < numbers.length; j++) {
            if (arr[i] === numbers[j].value) {
              numbers[j].disabled = false;
              numbers[j].checked = true;
              obj.dataset.value = '';
            }
          }
        }
      }
      // numbers.forEach(function (num) {
      //     if (!num.disabled && num.checked) {
      //         numberChange(num)
      //     }
      // });
      for (var i = 0; i < numbers.length; i++) {
        if (!numbers[i].disabled && numbers[i].checked) {
          this.numberChange(numbers[i]);
        }
      }
      this.toggleDialog();
    },

    numberChange(obj) {
      var el = document.getElementById(document.getElementById('selectBtn').dataset.id);
      var arr = (!!el.dataset.value && el.dataset.value.split(';')) || [];

      if (obj.checked) {
        arr.push(obj.value);
      } else {
        arr.splice(arr.indexOf(obj.value), 1);
      }

      el.dataset.value = arr.join(';');

      var selectBtn = document.getElementById('selectBtn');
      selectBtn.disabled = arr.length !== +selectBtn.dataset.num;
    },
    numberChangeDefault(e) {
      var el = document.getElementById(document.getElementById('selectBtn').dataset.id);
      var arr = (!!el.dataset.value && el.dataset.value.split(';')) || [];
      var obj = e.currentTarget;
      if (obj.checked) {
        arr.push(obj.value);
      } else {
        arr.splice(arr.indexOf(obj.value), 1);
      }

      el.dataset.value = arr.join(';');

      var selectBtn = document.getElementById('selectBtn');
      selectBtn.disabled = arr.length !== +selectBtn.dataset.num;
    },
    selectCard() {
      var numbers = document.getElementsByName('number');
      var el = document.getElementById(document.getElementById('selectBtn').dataset.id);
      var text = '';
      var element = el.dataset.value.split(';');
      for (var i = 0; i < element.length; i++) {
        if (element[i] < 13 || (25 < element[i] && element[i] < 39)) {
          text += '<span style="color:red">' + this.numberToCard(element[i]) + '</span>';
        } else {
          text += '<span>' + this.numberToCard(element[i]) + '</span>';
        }
      }
      for (var j = 0; j < numbers.length; j++) {
        if (!numbers[j].disabled && numbers[j].checked) {
          numbers[j].disabled = true;
        }
      }
      console.log(text);

      el.innerHTML = text;
      this.toggleDialog();
    },

    saveFunc() {
      var roomPath = document.getElementById('roomPath').value;
      var rid = document.getElementById('rid_input').value;
      var pcs = document.getElementById('pcs').dataset.value;

      if (!rid || !pcs) {
        alert('请检查遗漏');
        return;
      }
      // if(!/[0-9]{6}/.test(uid)){
      //     alert('ID错误');
      //     return
      // }
      if (!/([0-9]{6})$/.test(rid)) {
        alert('RID错误');
        return;
      }

      var hcs = [];
      for (var i = 1; i < 10; i++) {
        if (document.getElementById('hcs' + i).dataset.value) {
          hcs.push(document.getElementById('hcs' + i).dataset.value.replace(';', ','));
        } else {
          alert('请检查遗漏');
          return;
        }
      }

      var cards = pcs.split(';');
      var arr = hcs.join(',').split(',');
      for (let i = 0; i < arr.length; i++) {
        if (cards.indexOf(arr[i]) < 0) {
          cards.push(arr[i]);
        } else {
          alert('请勿选择重复');
          return;
        }
      }
      var data = {
        handsCards: hcs.join(';'),
        publicCards: pcs,
        roomId: rid,
        roomPath: roomPath,
        operateId: this.$store.state.login.userInfo.userId,
      };

      var r = confirm('确认选择？');
      if (r) {
        this.setCard(data).then(() => {
          this.$message.success('操作成功');
        });
      }
    },
  },
};
</script>
<style lang="scss">
.cardControl {
  .red {
    color: red;
  }
  table {
    width: 80%;
    margin: 100px auto 0;
    border-collapse: separate;
    border: 1px solid #ccc;
  }

  td {
    padding: 15px;
    background-color: #f6f6f6;
  }
  td > span {
    padding: 0 4px;
    font-size: 20px;
    font-weight: bold;
  }
  #pcs span {
    display: inline-block;
    width: 10%;
    box-sizing: border-box;
  }

  td:nth-of-type(n + 2) {
    text-align: center;
  }

  input[type='button'] {
    padding: 9px 24px;
    border: none;
    background-color: #33c0df;
    color: white;
    border-radius: 5px;
    cursor: pointer;
    outline: none;
  }

  input[type='button']:hover {
    background-color: #07d2ff;
  }

  #dialog {
    position: fixed;
    top: 0;
    left: 0;
    display: none;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .dialog-content {
    position: absolute;
    top: 40%;
    left: 50%;
    z-index: 3;
    width: 780px;
    padding: 0 20px;
    text-align: center;
    background-color: #fff;
    border: 1px solid #ccc;
    border-radius: 10px;
    transform: translate(-50%, -50%);
  }

  #selectBtn {
    margin-left: 20px;
  }

  #selectBtn:disabled {
    background-color: #ccc;
  }

  label {
    display: inline-block;
    width: 60px;
    text-align: center;
  }

  label input {
    position: absolute;
    opacity: 0;
  }

  label input:checked + span {
    background-color: #d0f0ff;
  }

  label input:disabled + span {
    background-color: #ccc;
  }

  label span {
    display: block;
    padding: 10px 0;
  }
  #roomPath {
    width: 70px;
    text-align: center;
    height: 30px;
    border: 1px solid #e4e4e4;
    background: white;
  }
  #rid_input {
    height: 40px;
    width: 100%;
    line-height: 40px;
    padding-left: 13px;
    border-radius: 4px;
    border: 1px solid #e8e8e8;
  }
}
</style>
